import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { mediaSource } from "../utilities/mediautilities";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Banner = ({ banners }) => {
    const [currentBanner, setCurrentBanner] = useState(banners[0]);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentBanner((prevBanner) => {
                const index = banners.findIndex((banner) => banner?._id === prevBanner?._id);
                const nextIndex = (index === banners?.length - 1) ? 0 : (index + 1)
                return banners[nextIndex];
            });
        }, 5000);
        return () => clearInterval(timer);
    }, [banners]);

    return (
        <>
            {banners?.length > 0 &&
                <section className="relative h-[85vh] overflow-hidden">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={currentBanner}
                            initial={{ opacity: 1 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 1 }}
                            transition={{ duration: 1.5, ease: "easeInOut" }}
                            className="absolute inset-0 w-full h-full"
                        >
                            <>
                                <img
                                    src={mediaSource(currentBanner?.payload?.image?.fileUrl)}
                                    alt=""
                                    className="w-full h-full object-cover"
                                    onError={(e) => mediaSource(e)}
                                />
                                <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />
                            </>
                        </motion.div>
                    </AnimatePresence>

                    {(currentBanner?.payload?.text || ((currentBanner?.payload?.button_link && currentBanner?.payload?.button_title))) &&
                        <motion.div
                            key={currentBanner?.payload?.text}
                            initial={{ opacity: 0, y: 40 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.2 }}
                            className="absolute inset-0 flex items-center z-10"
                        >
                            <div className="common-container w-full">
                                <div className="max-w-xl">
                                    {currentBanner?.payload?.text &&
                                        <h1 className="text-4xl md:text-6xl font-bold text-accent mb-6 leading-tight">
                                            {currentBanner?.payload?.text}
                                        </h1>
                                    }
                                    {(currentBanner?.payload?.button_link && currentBanner?.payload?.button_title) &&
                                        <button
                                            onClick={() => navigate(`/${currentBanner?.payload?.button_link}`)}
                                            className="bg-primary text-accent px-8 py-4 rounded-full text-lg hover:scale-110 transition-transform flex items-center gap-1"
                                        >
                                            {currentBanner?.payload?.button_title} <FaArrowRight size={15} />
                                        </button>
                                    }
                                </div>
                            </div>
                        </motion.div>
                    }

                    <div className="absolute bottom-6 w-full flex justify-center gap-3 z-20">
                        {banners?.map((banner, i) => (
                            <motion.button
                                key={i}
                                onClick={() => setCurrentBanner(banner)}
                                whileHover={{ scale: 1.5 }}
                                className={`w-3 h-3 rounded-full transition
                                ${banner?._id === currentBanner?._id ? "bg-accent scale-125" : "bg-accent"}`}
                            />
                        ))}
                    </div>
                </section>
            }
        </>
    )
}

export default Banner;